const DBObjectIds = {
  EFMigrationsHistory: 1,
  Activities: 2,
  ActivityActionLogs: 3,
  ActivityCategories: 4,
  ActivitySchoolClubs: 5,
  ActivityTours: 6,
  ActivityVenues: 7,
  AdminParentChats: 8,
  AdmissionEnquires: 9,
  AdmissionEnquireTypes: 10,
  AdmissionVoucherDetails: 11,
  AdmissionVouchers: 12,
  AlertNotifications: 13,
  Approvals: 14,
  Assessment: 15,
  AssessmentDetail: 16,
  AssessmentPlanDetails: 17,
  AssessmentPlans: 18,
  AssessmentResultDetails: 19,
  AssessmentResults: 20,
  AssessmentTypes: 21,
  AssignAlertNotifications: 22,
  Authors: 23,
  BankSetups: 24,
  BookFines: 25,
  BookLoans: 26,
  BookRequests: 27,
  Books: 28,
  CampusActivityAfterSchoolClubs: 29,
  CampusActivityApplicationInvoices: 30,
  CampusActivityApplications: 31,
  CampusActivityAttendance: 32,
  CampusActivityClassSections: 33,
  CampusActivityCreditNotesInvoices: 34,
  CampusActivityEventDates: 35,
  CampusActivityEvents: 36,
  CampusActivityFecilityRentals: 37,
  CampusActivitySlots: 38,
  CampusContracts: 39,
  CenterAssessmentPlanDetails: 40,
  CenterAssessmentPlans: 41,
  CenterAttendancePermissions: 42,
  CenterClases: 43,
  CenterConcessionTypeDetails: 44,
  CenterConcessionTypes: 45,
  CenterFeePlanDetails: 46,
  CenterFeePlans: 47,
  CenterLevels: 48,
  Centers: 49,
  CenterSessions: 50,
  ChallanDueDates: 51,
  Cities: 52,
  cities: 53,
  ClassAchievementRatings: 54,
  Classes: 55,
  ClassSections: 56,
  ClassSubjects: 57,
  ClassTestResults: 58,
  ClientNotifications: 59,
  ClientNotificationsHTML: 60,
  ColumnFilterModes: 61,
  CommonSettingDetails: 62,
  CommonSettings: 63,
  ConcessionRules: 64,
  ConcessionTypeDetails: 65,
  ConcessionTypes: 66,
  Countries: 67,
  DataTable: 68,
  DatatableFilter: 69,
  DBObject: 70,
  DeviceAssignments: 71,
  ElementDetails: 72,
  Elements: 73,
  EmailAlertSetups: 74,
  EvaluationCriteriaClassWeightages: 75,
  EvaluationCriteriaPercentages: 76,
  EvaluationCriterias: 77,
  EvaluationCriteriaTypes: 78,
  EvaluationSubjectItemHeads: 79,
  EvaluationTypes: 80,
  FeeCycles: 81,
  FeedbackCategories: 82,
  FeedbackForms: 83,
  FeePlanDetails: 84,
  FeePlans: 85,
  FeeTypes: 86,
  FileAppMenu: 87,
  FileAppMenuDetail: 88,
  FileDocuments: 89,
  FilterColumn: 90,
  FilterColumnSorting: 91,
  FirstRegistrationDocumentTags: 92,
  FormApiMethods: 93,
  FormCategories: 94,
  FormElementAllocations: 95,
  Forms: 96,
  FormSubCategories: 97,
  ImportedStudentData: 98,
  ITDevices: 99,
  ItemCategories: 100,
  Items: 101,
  Languages: 102,
  Libraries: 103,
  LibraryMembers: 104,
  MedicalAuthorization: 105,
  MedicalCondition: 106,
  MeetingPersons: 107,
  MeetingReasons: 108,
  Meetings: 109,
  MeetingTime: 110,
  MobileActiveDrivers: 111,
  MobileAppClassWorks: 112,
  MobileAppDailyDiaries: 113,
  MobileAppDriverTrips: 114,
  MobileEarlyLeaveRequests: 115,
  MobileNotifactions: 116,
  MobileNotificationTypes: 117,
  MobilePublicityContents: 118,
  MobileQueryComplaintCategories: 119,
  MobileQueryComplaintResponses: 120,
  MobileQueryComplaints: 121,
  MobileQueryComplaintSubCategories: 122,
  MobileStudentBarCodes: 123,
  MobileUserFcmTokens: 124,
  MonthlyStudentChallans: 125,
  NotificationAttachments: 126,
  NotificationAttachments_Copy: 127,
  NotificationAttachmentTemplate: 128,
  NotificationAttachmentTemplate_Copy: 129,
  NotificationCriteria: 130,
  NotificationCriteria_Copy: 131,
  NotificationDelivered: 132,
  NotificationDelivered_Copy: 133,
  NotificationEventType: 134,
  NotificationEventType_Copy: 135,
  NotificationFormEvent: 136,
  NotificationFormEvent_Copy: 137,
  NotificationOccurence: 138,
  NotificationOccurence_Copy: 139,
  NotificationTemplate: 140,
  NotificationTemplate_Copy: 141,
  NotificationType: 142,
  NotificationType_Copy: 143,
  OrderItems: 144,
  Orders: 145,
  OrganizationLevelDetails: 146,
  OrganizationLevels: 147,
  Organizations: 148,
  OrganizationUser: 149,
  ParentQuestioners: 150,
  PerformanceEvaluationMarkDetails: 151,
  PerformanceEvaluationMarks: 152,
  Permissions: 153,
  Products: 154,
  Registrations: 155,
  RegistrationVoucherDetails: 156,
  RegistrationVouchers: 157,
  RelationNotificationTemplateAndAttachmentTemplate: 158,
  RelationNotificationTemplateAndCategorySubCategories: 160,
  RolePermissions: 161,
  Roles: 162,
  SalesOfferItemImages: 163,
  SalesOfferItems: 164,
  SalesOfferItemSizes: 165,
  SalesOffers: 166,
  ScheduleLogs: 167,
  ScheduleLogTeacherEmails: 168,
  Sections: 169,
  SectionSubjects: 170,
  SessionPeriods: 171,
  Sessions: 172,
  Sheet2: 173,
  Siblings: 174,
  States: 175,
  states: 176,
  StdAttnCalenderDayTypes: 177,
  StdAttnCalenderHolidays: 178,
  StdAttnCalenders: 179,
  StdAttns: 180,
  StdAttnTypes: 181,
  StudentAchievementRatings: 182,
  StudentCareTakerAssignments: 183,
  StudentDocuments: 184,
  StudentEvaluationCriterias: 185,
  StudentFamilyInformations: 186,
  StudentFirstRegistrations: 187,
  StudentMedicalDocuments: 188,
  StudentMedicalInformations: 189,
  StudentPreviousSchool: 190,
  StudentRegistrationRemark: 191,
  Students: 192,
  StudentSectionSubject: 193,
  StudentStrengthComparisonYearly: 194,
  StudentTransfers: 195,
  Subject: 196,
  SubjectClassEvaluationCriterias: 197,
  SummaryStatistics: 198,
  SuperCategories: 199,
  SurveyAnswer: 200,
  SurveyAnswerCategory: 201,
  SurveyCategory: 202,
  SurveyQuestionCategory: 203,
  SurveyQuestions: 204,
  SurveyUserAnswer: 205,
  sysdiagrams: 206,
  TeacherParentCommunications: 207,
  TimeSlots: 208,
  Timetables: 209,
  UnitOfMeasures: 210,
  UserLogin: 211,
  UserPermissions: 212,
  UserRoles: 213,
  Users: 214,
  UserTypes: 215,
  Withdrawals: 216,
  WithdrawalVoucherDetails: 217,
  WithdrawalVouchers: 218,
  WorkflowAction: 219,
  WorkflowInstance: 220,
  WorkflowInstanceStep: 221,
  WorkflowProcess: 222,
  WorkflowStatus: 223,
  WorkflowStep: 224,
  WorkflowStepAssignment: 225,
  WorkflowTransition: 226,
  Worksheet: 227,
};

export default DBObjectIds;
